import { Link } from "@tanstack/react-router";
import { Shield, BadgeCheck, MapPin, ThumbsUp, Quote } from "lucide-react";

const badges = [
  { icon: Shield, label: "Fully insured", text: "Public liability cover on every clean." },
  { icon: BadgeCheck, label: "Vetted & verified", text: "ID-checked, trained and reference-checked cleaners." },
  { icon: MapPin, label: "Local & independent", text: "Based on Salisbury Plain — not a national call centre." },
  { icon: ThumbsUp, label: "Satisfaction guarantee", text: "Not happy with something? We come back and put it right." },
];

const quotes = [
  {
    text: "Reliable, thorough and always on time. Our house in Tidworth has never looked better.",
    name: "Local homeowner, Tidworth",
  },
  {
    text: "They cleaned our SFA for march-out and we passed first time with no re-clean. Huge relief.",
    name: "Service family, Tidworth Garrison",
  },
  {
    text: "Booked an end of tenancy clean at short notice — full deposit back. Would use again.",
    name: "Tenant, Ludgershall",
  },
];

export function TrustedLocal() {
  return (
    <section className="py-20 md:py-24">
      <div className="container-x">
        <div className="text-surface max-w-2xl">
          <span className="eyebrow">Trusted locally</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl">
            Trusted cleaning in <span className="rainbow-text">Tidworth</span>.
          </h2>
          <p className="mt-4 text-muted-foreground">
            IZHUB Cleaning Services is a local, insured and independently run cleaning company serving Tidworth, Perham Down,
            Ludgershall, Shipton Bellinger, Bulford, Larkhill and the wider Salisbury Plain.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {badges.map((b) => (
            <div key={b.label} className="rounded-3xl border border-border bg-card p-6">
              <span className="grid h-11 w-11 place-items-center rounded-2xl bg-sage-soft text-primary">
                <b.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 font-display text-lg">{b.label}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{b.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {quotes.map((q) => (
            <figure key={q.name} className="rounded-3xl border border-sage/30 bg-sage-soft/40 p-6">
              <Quote className="h-5 w-5 text-primary" aria-hidden="true" />
              <blockquote className="mt-3 text-sm text-foreground/90 leading-relaxed">{q.text}</blockquote>
              <figcaption className="mt-4 text-xs text-muted-foreground">{q.name}</figcaption>
            </figure>
          ))}
        </div>

        <div className="text-surface mt-8 w-fit">
          <p className="text-sm text-muted-foreground">
            Want the same for your home?{" "}
            <Link to="/quote" className="text-primary underline underline-offset-4">Get your instant quote</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}
